import { httpConfig } from "./httpConfig";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { json, useLocation, useNavigate } from "react-router-dom";
import { CheckingLogin } from "./controll_login";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { Icon } from "@iconify/react";
import { ProtectedLogin } from "./protectedlogin";
import { RequestFetch } from "./config/requestFetch";
import {
  encodeAndStoreData,
  encodeDataforkey,
  getdataAndDecodeStoreData,
} from "./config/encodelocalstorage";
import { Addmetatags } from "./config/addmetatags";
import { ReactComponent as MyiconTwohand } from "./images/icon_twohand_holding_paper.svg";

const Wardroundpage = (props) => {
  // ตั้งค่าตัวแปร
  const http = httpConfig();
  const navigat = useNavigate();
  const location = useLocation();

  const advisorData = localStorage.getItem("advisor")
    ? JSON.parse(localStorage.getItem("advisor"))
    : "";
  const [wardroundList, setWardroundList] = useState(() => {
    if (getdataAndDecodeStoreData("work")) {
      return getdataAndDecodeStoreData("work");
    } else {
      return [];
    }
  });
  const [studentInfo, setStudentInfo] = useState([]);
  const [groupAssassment, setGroupAssassment] = useState([]);
  const [checkingBox, setCheckingBox] = useState([]);
  const [filterHandle, setFilterHandle] = useState(true);
  const [choiceDoctorshare, setChoiceDoctorshare] = useState(true);
  const [filterWork, setFilterWork] = useState([]);
  const [undisbleFinishwork, setUndisbleFinishwork] = useState([]);
  const [reload, setReload] = useState(false);
  const [advisorlistdata, setAdvisorlistdata] = useState([]);
  const [holderWorkid, setHolderWorkid] = useState("");
  const [finishSharestatus, setFinishSharestatus] = useState(false);

  const [statusOpencloseShare, setStatusOpencloseShare] = useState(true);
  const [statusOpencloseNotification, setStatusOpencloseNotification] =
    useState(true);

  const [statusNotification, setStatusNotification] = useState(false);
  const [notificationnumber, setNotificationnumber] = useState(0);
  const [dataforNotification, setDataforNotification] = useState([]);
  const [reportstudentgroup, setReportstudentgroup] = useState([]);
  const [datascoreCheckshare, setDatascoreCheckshare] = useState(null);
  const cookies = new Cookies();
  const usertoken = cookies.get("tokenEstimate");

  const today = new Date();

  // ดึงข้อมูลงานทั้งหมดของอาจารย์คนนั้น
  function getShowWardround(advisorID) {
    // console.log("อาจารย์IDDDDDDDDD->", advisorID);
    let bodyrequest = { id: advisorID };

    fetch(`${http}/work`, RequestFetch("POST", bodyrequest, usertoken)).then(
      (res) =>
        res.json().then((data) => {
          // console.log("ตอนนี้ข้อมูลที่แสดง work =>", data);
          //ยังไม่ได้จัดทำ
          // เพิ่มขั้นตอนการเช็คค่า เพื่อ จัดเก็บข้อมูลงานที่จบแล้ว
          // จัดเก็บไว้บน localStorage โดยใช้ชื่อ "done"
          let arr = [];
          let HiddenWork = [];
          if (localStorage.getItem("done")) {
            let localDone = JSON.parse(localStorage.getItem("done"));

            if (localDone) {
              let numberNotification = 0;
              let dataNotifArr = [];
              data.map((data) => {
                let pass = true;
                localDone.map((ele) => {
                  if (ele.wkID.toString() === data.workID.toString()) {
                    // console.log(
                    //   "วันที่เริ่มงาน",
                    //   moment(data.start).fromNow().split(" ")
                    // );

                    // เปลี่ยน ตัวเช็คเงื่อนไขเวลา เป็น date และดึงตัวเวลามาโชว์
                    // เปลี่ยน data.start ~~ เป็น data.date
                    // console.log("data", data.date);
                    // console.log("--->", moment("2023-04-12T17:00:00.000z").fromNow().split(" "));
                    // console.log("!!!-->", moment(data.date).format("DD/MM/YYYY"));
                    // console.log(
                    //   "--->",
                    //   moment(data.date).fromNow().split(" "),
                    //   data.workID
                    // );
                    // console.log(moment(data.date).fromNow().split(" "));
                    // console.log(moment(data.date).format("MM"));
                    // console.log(moment(new Date()).format("MM"));

                    if (
                      moment(data.date).format("MM/YYYY") !==
                      moment(new Date()).format("MM/YYYY")
                    ) {
                      // console.log("ผ่านมาเป็นเดือนนะจ๊ะ workid =>", data.workID);
                      HiddenWork.push({ idwork: data.workID });
                      pass = false;
                    }
                  }
                });
                if (pass) {
                  arr.push(data);
                }

                // if (data.share === advisorID && data.status_read === 0) {
                //   numberNotification++;
                //   dataNotifArr.push(data);
                // } else if (data.share === advisorID) {
                //   dataNotifArr.push(data);
                // }
              });
              // if (numberNotification) {
              //   setStatusNotification(true);
              // } else {
              //   setStatusNotification(false);
              // }
              // setNotificationnumber(numberNotification);
              // // console.log("datanotification >>", dataNotifArr);
              // setDataforNotification(dataNotifArr);
            }
            //เช็คค่าข้อมูลเก่าที่เก็บไว้ใน localstorage ก่อนว่ามีค่าอะไรเปลี่ยนแปลงหรือไม่ ก่อนจะทำการ setWardroundList
            let checksetingworkarr = checkForSetworkListOrnot(arr);
            checksetingworkarr.then((res) => {
              if (res) {
                encodeAndStoreData("work", arr);
                setWardroundList(arr);
              }
            });
          } else {
            let thisDone = [];
            let notDone = [];

            data.map((data) => {
              if (data.complete) {
                if (data.complete === 1) {
                  thisDone.push({ wkID: data.workID.toString() });
                  // console.log(moment(data.date).fromNow().split(" "));

                  if (
                    moment(data.date).format("MM/YYYY") ===
                    moment(new Date()).format("MM/YYYY")
                  ) {
                    console.log("ยังไม่เลยเดือนและปี");
                    notDone.push(data);
                  }
                } else {
                  notDone.push(data);
                }
              } else {
                notDone.push(data);
              }
            });

            // console.log("อันนี้ this Done เท่ากับ ==>", thisDone);
            // console.log("omg here look =>", notDone);

            localStorage.setItem("done", JSON.stringify(thisDone));

            //เช็คค่าข้อมูลเก่าที่เก็บไว้ใน localstorage ก่อนว่ามีค่าอะไรเปลี่ยนแปลงหรือไม่ ก่อนจะทำการ setWardroundList
            let checksetingworknotdone = checkForSetworkListOrnot(notDone);
            checksetingworknotdone.then((res) => {
              if (res) {
                console.log("no complate", notDone);
                encodeAndStoreData("work", notDone);
                setWardroundList(notDone);
              }
            });
          }

          // ต้องดูจาก เมื่อคลิกจบงาน แล้ว work ดาต้า จะได้ค่า data.date กับ data.start
          // มาเช็คว่างานนี้มันเลยวัน ถ้ามันเลยวัน พอกด จบงานแล้วก็จะ ไม่โชว์จากหน้า worklist

          // if (data) {
          //   data.map((data) => {
          //     // รายการกลุ่มที่นักศึกษาทั้งหมดในกลุ่ม

          //     if (data.grop) {
          //       if (data.stop === "0000-00-00") {
          //         arr.push(data);
          //       } else {
          //         let aMatch = moment(data.stop).fromNow().match("in")
          //           ? moment(data.stop).fromNow().match("in")[0]
          //           : "error";
          //         if (aMatch === "in") {
          //           arr.push(data);
          //         }
          //       }
          //     } else {
          //       // รายการเดียวที่นักศึกษาแต่ละคน ไม่มีกลุ่ม

          //       if (data.IdStudent) {
          //         if (data.stop === "0000-00-00") {
          //           arr.push(data);
          //         } else {
          //           let aMatch = moment(data.stop).fromNow().match("in")
          //             ? moment(data.stop).fromNow().match("in")[0]
          //             : "error";
          //           if (aMatch === "in") {
          //             arr.push(data);
          //           }
          //         }
          //       }
          //     }
          //   });
          // }
          // console.log(arr);
        })
    );
  }

  async function checkForSetworkListOrnot(data) {
    let localwork = localStorage.getItem("work");

    if (localwork) {
      let getworkdata = await getdataAndDecodeStoreData("work").sort();
      let datafetch = await data.sort();
      let lengthgetworkdata = getworkdata.length;
      let lengthdatafetch = datafetch.length;

      // console.log("this decodetrying =>", getworkdata);
      // console.log("this data =>>", datafetch);
      // console.log(
      //   "lengthfor look ..>",
      //   lengthgetworkdata,
      //   "|",
      //   lengthdatafetch
      // );
      let itchange = await getworkdata.map((res, index) => {
        if (!datafetch[index]) {
          return true;
        }
        if (
          res.workID !== datafetch[index].workID ||
          res.IdStudent !== datafetch[index].IdStudent ||
          res.advisor_name !== datafetch[index].advisor_name ||
          res.advisor_lname !== datafetch[index].advisor_lname ||
          res.advisor_ttl !== datafetch[index].advisor_ttl ||
          res.cancle !== datafetch[index].cancle ||
          res.date !== datafetch[index].date ||
          res.complete !== datafetch[index].complete ||
          res.confirm !== datafetch[index].confirm ||
          res.grop !== datafetch[index].grop ||
          res.groupID !== datafetch[index].groupID ||
          res.share !== datafetch[index].share ||
          res.sheet !== datafetch[index].sheet ||
          res.sheetID !== datafetch[index].sheetID ||
          res.start !== datafetch[index].start ||
          res.status_read !== datafetch[index].status_read ||
          res.stop !== datafetch[index].stop ||
          res.timebegin !== datafetch[index].timebegin ||
          res.timeend !== datafetch[index].timeend
        ) {
          return true;
        } else {
          return false;
        }
      });
      // console.log("itchange ==>", itchange);
      //บัค เพราะ มันจะทำการเช็ตค่าใน สโต ทุกครั้ง
      //มีข้อมูลไม่เท่ากัน ดึงใหม่สิรอไร
      if (lengthgetworkdata !== lengthdatafetch) {
        return true;
      }
      if (itchange.indexOf(true) === -1) {
        return false;
      } else {
        return true;
      }
    } else {
      encodeAndStoreData("work", data);
      return true;
    }
  }

  // ดึงข้อมูลของอาจารย์คนนั้น ตามวันที่
  function getShowFilterWardlist(advisorID, amonth, ayear) {
    setReload(true);

    let requestOption = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${usertoken}`,
        "content-type": "application/json",
      },
      body: JSON.stringify({ id: advisorID, year: ayear, month: amonth }),
    };

    let bodyrequest = {
      id: advisorID,
      year: ayear,
      month: amonth,
    };

    fetch(
      `${http}/workFilter`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        console.log("data workFilter is a =>", data);
        let dataDone = [];
        let dataNotifArr = [];
        let thisforSetData = [];
        data.map((res) => {
          if (parseInt(res.complete) === 1) {
            dataDone.push({ wkID: res.workID.toString() });
            localStorage.setItem("done", JSON.stringify(dataDone));
          }

          if (res.share === advisorID) {
            if (res.date) {
              let Resmonth = moment(res.date).format("MM");
              let Resyear = moment(res.date).format("YYYY");
              if (
                parseInt(Resmonth) === amonth &&
                parseInt(Resyear) === ayear
              ) {
                thisforSetData.push(res);
              }
              dataNotifArr.push(res);
            }
          } else {
            thisforSetData.push(res);
          }

          setTimeout(() => {
            try {
              checkBoxisChecking(res.workID);
            } catch (error) {
              //ไม่ทำอะไร เมื่อมีการ catch
            }
          }, 500);
        });
        try {
          setWardroundList(thisforSetData);
        } catch (error) {
          //ไม่ทำอะไร เมื่อมีการ catch
        }
      })
    );
  }

  // ดึงข้อมูลของนศพตามเลขกลุ่ม
  function getStudentInfo(grp, advisorId) {
    if (!grp) return;
    let bodyrequest = {
      group: grp,
    };
    fetch(
      `${http}/studentINgroup`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        // console.log("ข้อมูลนักเรียนในกลุ่ม->", data);
        setStudentInfo(data);
      })
    );
  }

  async function getIDstudent(studentId) {
    let requestGetID = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${usertoken}`,
        "content-type": "application/json",
      },
      body: JSON.stringify({
        IdStudent: studentId,
      }),
    };

    let bodyrequest = { IdStudent: studentId };
    let data = await fetch(
      `${http}/sutdentGetId`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) => res.json());
    return data;
  }

  function checkAssageMentStudent(IdStudent, sheetId) {
    let requestCheckAssessment = {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        IdSdt: IdStudent,
        Idsheet: sheetId,
      }),
    };
    let bodyrequest = { IdSdt: IdStudent, Idsheet: sheetId };
    fetch(
      `${http}/checkassessmentstudent`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        if (data[0]) {
          console.log(data);
          // setGroupAssassment(data);
          let object = {
            IDsheet: sheetId,
            status: true,
          };
        }
      })
    );
  }

  // ตัวแปรจัดการจัดสรรค่าใน ฟังชั่น checkWorkDetailCheckAssessment
  const totalHLdb = [];
  const resultCheckFail = [];
  const undisblecheckbox = [];

  // เช็คค่าในงานนั้นๆ ที่มีการประเมินนศพ เรียบร้อย (มีคะแนน)
  async function checkWorkDetailCheckAssessment(workID, sheetId, group) {
    let resquestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        idwork: workID,
      }),
    };

    let bodyrequest = {
      idwork: workID,
    };
    // if (workID === 5) return
    // console.log("parametor is a =>", sheetId, workID);

    // ดึงจาก localStorage highlight
    let resultHLdb = [];

    //ยังไม่ได้จัดทำ
    // เพิ่มขั้นตอนการเช็คค่า เพื่อ จัดเก็บข้อมูลงานที่จบแล้ว
    // จัดเก็บไว้บน localStorage โดยใช้ชื่อ "done"
    // ดูจาก workid , group , studentID , advisorID ดึงเก็บเพิ่มจาก ตาราง highlight

    if (localStorage.getItem("highlight")) {
      //ดึงค่าจาก localstorage
      let highlightDATA = JSON.parse(localStorage.getItem("highlight"));
      // console.log("this a parameter :", sheetId);
      if (highlightDATA[0]) {
        highlightDATA.map((hlDB) => {
          if (hlDB.workId.toString() === workID.toString()) {
            if (hlDB.sheetId.toString() === sheetId.toString()) {
              resultHLdb.push(hlDB);
            }
          }
        });
      }
    }

    // console.log(
    //   "resultHldb ตอนทำเงื่อนไขมี highlight เสร็จแล้ว ค่า >>>",
    //   resultHLdb
    // );

    // console.log("now resultHLdb is a :", resultHLdb, workID);

    // เช็คกับฐานข้อมูล

    fetch(
      `${http}/workDetailCheckAssessment`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) => {
      res.json().then(async (data) => {
        // console.log("ดึงข้อมูลworkdetail ที่มีทั้งคะแนนและไม่มีคะแนน", data);
        // console.log("data have point?", data, workID);
        let objectHL = {};
        let scorePass = true;

        // เช็คค่าว่ามีค่าที่ยังไม่ได้ประเมินในการดึง workdetail
        let checkDisGreen = { work: workID, status: "" };
        // console.log("ขอดู resScore หน่อย", workID, data);

        await data.map((res) => {
          let objforhighlight = {
            group: group,
            sheetId: sheetId,
            studentID: res.studentID,
            workId: workID,
          };
          totalHLdb.push(objforhighlight);

          if (!res.score) {
            checkDisGreen = { work: workID, status: false };
            return;
          } else {
            checkDisGreen = { work: workID, status: true };
            if (sheetId === 1 || sheetId === 8) {
              document.getElementById(
                `btniconarrowshare-${workID}`
              ).style.display = "none"; //ไม่โชว์ปุ่ม share
            }
          }
        });

        // console.log("status checkDisgreen :(", checkDisGreen);

        if (checkDisGreen.status === true) {
          document
            .getElementById(`text-namework-${workID}`)
            .classList.add("card-has-asses");
          undisblecheckbox.push({ workid: workID });
        } else if (checkDisGreen.status === false) {
          document
            .getElementById(`text-namework-${workID}`)
            .classList.remove("card-has-asses");
          resultCheckFail.push({ workId: workID, status: false });
        }

        // console.log("เปิดหรือปิดตัวเช็คเพื่อจบงานนั้น ๆ =>", resultCheckFail);
        // console.log("highlight ทั้งหมดที่จะเซ็ตคือ =>", totalHLdb);
        setCheckingBox(resultCheckFail);
        setUndisbleFinishwork(undisblecheckbox);
        localStorage.setItem("highlight", JSON.stringify(totalHLdb));
      });
    });
  }

  // สร้างชื่อเดือนไทย
  function handelMonthThai(month, status) {
    if (status === "full") {
      switch (parseInt(month).toString()) {
        case "1":
          return "มกราคม";
        case "2":
          return "กุมภาพันธ์";
        case "3":
          return "มีนาคม";
        case "4":
          return "เมษายน";
        case "5":
          return "พฤษภาคม";
        case "6":
          return "มิถุนายน";
        case "7":
          return "กรกฏาคม";
        case "8":
          return "สิงหาคม";
        case "9":
          return "กันยายน";
        case "10":
          return "ตุลาคม";
        case "11":
          return "พฤศจิกายน";
        case "12":
          return "ธันวาคม";
      }
    }
    if (status === "drop") {
      // console.log(month, status);
      switch (month.toString()) {
        case "01":
          return "ม.ค.";
        case "02":
          return "ก.พ.";
        case "03":
          return "มี.ค.";
        case "04":
          return "เม.ย.";
        case "05":
          return "พ.ค.";
        case "06":
          return "มิ.ย.";
        case "07":
          return "ก.ค.";
        case "08":
          return "ส.ค.";
        case "09":
          return "ก.ย.";
        case "10":
          return "ต.ค.";
        case "11":
          return "พ.ย.";
        case "12":
          return "ธ.ค.";
      }
    }
  }

  //กำหนดค่าของ filter เริ่มต้นด้วยเดือนปัจจุปัน ไปจนถึง 5 ปี ย้อนหลัง
  function selectfilterWork() {
    let monthToday = new Date().getMonth() + 1;
    let yearToday = moment(new Date()).add(543, "year").format("YY");
    let fullYear = parseInt(moment(new Date()).format("YYYY"));
    let countMonth = parseInt(monthToday);
    let countYear = parseInt(yearToday);
    let countYearNUM = 5; //กำหนดค่าปีที่จะย้อนหลัง
    let resultDATA = [];
    // console.log("what this is =>", countMonth);
    // console.log("what this year =>", yearToday);

    while (countYearNUM > 0) {
      resultDATA.push({
        monthNum: countMonth,
        month: handelMonthThai(
          countMonth < 10 ? `0${countMonth}` : `${countMonth}`,
          "drop"
        ),
        year: countYear,
        fullYear: fullYear,
      });
      while (countMonth > 1) {
        countMonth--;
        resultDATA.push({
          monthNum: countMonth,
          month: handelMonthThai(
            countMonth < 10 ? `0${countMonth}` : `${countMonth}`,
            "drop"
          ),
          year: countYear,
          fullYear: fullYear,
        });
      }

      if (countMonth === 1) {
        countYear = countYear - 1;
        fullYear--;
        countMonth = 12;
      }

      // console.log(">>>", countMonth);
      // console.log("!!!", countYear);
      countYearNUM--;
    }

    setFilterWork(resultDATA);
    // console.log("result ==>", resultDATA);

    // while ()

    // console.log("today is a day =>", monthToday, yearToday);
  }

  // รับค่าจัดการค่า filter บน localStorage
  function handleFilterSETwork(month, year, thYear) {
    // console.log("year :", year, "month :", month);

    localStorage.setItem(
      "filterWork",
      JSON.stringify({ ayear: year, amonth: month, yearth: thYear })
    );

    getShowFilterWardlist(advisorData.advisor_id, month, year);

    handleOpenFilterModal(false);
  }

  // เช็คและจัดการ เมื่อมีค่า highlight ที่ตั้งไว้ เมื่อกดไปยัง หน้าไหนบ้าง
  function handelChooseListWork(
    group,
    sheetId,
    workId,
    studentId,
    shareId,
    sheetname,
    confirmShare,
    date_work
  ) {
    let passresult = true;
    if (shareId) {
      let advisor = JSON.parse(localStorage.getItem("advisor"));
      // console.log("what the ...", confirmShare);
      if (parseInt(confirmShare) === 0 || !confirmShare) {
        passresult = false;
        handlecheckconfirmshare(advisor.advisor_id, shareId, workId, sheetname);
      } else {
        if (shareId !== advisorData.advisor_id) {
          let promissname = getDataLooknameAdvisor(shareId);
          promissname.then((data) => {
            // console.log(">>?", data);
            Swal.fire({
              icon: "info",
              title: "ผู้รับผิดชอบประเมินงาน",
              text: `${data[0].ttl} ${data[0].name} ${data[0].lname} เป็นผู้รับผิดชอบประเมินงานแทน`,
              confirmButtonText: "ตกลง",
            });
          });
          return;
        }
        // console.log("shareid !!!!", shareId);
      }
      // handlecheckconfirmshare(advisor.advisor_id, shareId, workId, sheetname);
    }
    console.log("ทำงานต่อ", passresult);
    if (passresult) {
      let dataHighlight = JSON.parse(localStorage.getItem("highlight"));
      let passthis = false;
      // console.log("-------------------------", studentId);
      if (studentId) {
        navigat(
          `/assessment/${studentId}/${group}/${sheetId}/${workId}?timestamp=${new Date().getTime()}`
        );
      } else {
        if (dataHighlight) {
          // console.log("มี highlight");
          dataHighlight.map((ele) => {
            if (ele.workId.toString() === workId.toString()) {
              if (parseInt(ele.sheetId) === parseInt(sheetId)) {
                passthis = true;
              }
            }
          });
        } else {
          // console.log("ไม่มี highlight");
          navigat(
            `/grouplist/${group}/${sheetId}/${workId}?timestamp=${new Date().getTime()}`
          );
        }
        if (!passthis) {
          // console.log("is not have highlight");
          navigat(
            `/grouplist/${group}/${sheetId}/${workId}?timestamp=${new Date().getTime()}`
          );
        } else {
          console.log("have highlight", group);
          navigat(
            `/grouplistHL/${group}/${sheetId}/${workId}?timestamp=${new Date().getTime()}`
          );
        }
      }
    }
  }

  // เช็คค่า เมื่อมีการกด checkbox เพื่อปิดงานประเมิน เมื่อกดเปิดการประเมินอีกครั้ง
  async function handleSetLocalTohighlight(value, workId) {
    if (localStorage.getItem("done")) {
      let localDATA = JSON.parse(localStorage.getItem("done"));
      let pass = true;
      let newArr = []; //รับค่าข้อมูลใหม่เพื่อจัดเก็บค่า highlight
      localDATA.map((res) => {
        if (res.wkID === value) {
          pass = false;
        } else {
          newArr.push(res);
        }
      });
      if (pass) {
        if (value) {
          let arr = [];
          wardroundList.map((data) => {
            let pass = true;
            if (value.toString() === data.workID.toString()) {
              // console.log("เมื่อ checkbox ture", data.workID);

              if (!localStorage.getItem("filterWork")) {
                // console.log("ไม่มี filter");
                if (
                  moment(data.date).format("MM") !==
                  moment(new Date()).format("MM")
                ) {
                  pass = false;
                }
              }
            }
            if (pass) {
              arr.push(data);
            }
          });
          // console.log("that work or not! see==>", arr);
          //ตัดการ เพิ่มสีและเช็คบนเช็คบล็อค
          let l = 0;
          while (l < document.getElementsByClassName("card-content").length) {
            document
              .getElementsByClassName("card-content")
              [l].classList.remove("card-check");
            document.getElementsByClassName("checkboxwork")[l].checked = false;
            document
              .getElementsByClassName(`grid-sheetname`)
              [l].classList.remove("card-has-asses");
            l++;
          }
          setWardroundList(arr);
        }

        Swal.fire({
          icon: "success",
          text: "ตรวจเสร็จแล้ว",
          showConfirmButton: false,
          timer: 1500,
        });

        //ยังไม่ได้จัดทำ
        // อัพเดทสถานะการทำงาน จบงานแล้ว

        // console.log("อัพเดทสถานะจบการทำงานนี้แล้ว", 1, workId);
        fetchConfirmAddComplete(1, workId);
        localDATA.push({ wkID: value });
        localStorage.setItem("done", JSON.stringify(localDATA));
      } else {
        // Swal.fire({
        //   icon: "warning",
        //   text: "ยกเลิกตรวจงานเสร็จ",
        //   showConfirmButton: false,
        //   timer: 1500,
        // });

        Swal.fire({
          text: "ต้องการกลับไปประเมินใหม่ ใช่ หรือ ไม่",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#33691e",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.setItem("done", JSON.stringify(newArr));
            // console.log("workid ที่ส่งมามีค่าเท่ากับ +>", workId);

            // ยังไม่ได้จัดทำ
            // อัพเดทข้อมูลสถานะการทำงาน ว่ายังทำงานไม่เสร็จ
            // console.log("อัพเดทสถานะจบการทำงานนี้แล้ว", 0, workId);
            fetchConfirmAddComplete(0, workId);

            document
              .getElementById(`card-grp-${workId}`)
              .classList.remove("card-check");
            document.getElementById(`thischeckGrid-${workId}`).checked = false;
          } else {
            document.getElementById(`thischeckGrid-${workId}`).checked = true;
          }
        });
      }
    } else {
      if (value) {
        let arr = [];
        wardroundList.map((data) => {
          let pass = true;
          if (value.toString() === data.workID.toString()) {
            if (
              moment(data.date).format("MM") !== moment(new Date()).format("MM")
            ) {
              pass = false;
            }
          }
          if (pass) {
            arr.push(data);
          }
        });
        console.log("that work or not! see==>", arr);
        //ตัดการ เพิ่มสีและเช็คบนเช็คบล็อค
        let l = 0;
        while (l < document.getElementsByClassName("card-content").length) {
          document
            .getElementsByClassName("card-content")
            [l].classList.remove("card-check");
          document.getElementsByClassName("checkboxwork")[l].checked = false;
          document
            .getElementsByClassName(`grid-sheetname`)
            [l].classList.remove("card-has-asses");
          l++;
        }
        setWardroundList(arr);
      }

      //ยังไม่ได้จัดทำ
      // อัพเดทสถานะการทำงาน จบงานแล้ว
      Swal.fire({
        icon: "success",
        text: "ตรวจเสร็จแล้ว",
        showConfirmButton: false,
        timer: 1500,
      });

      console.log("อัพเดทสถานะจบการทำงานนี้แล้ว", 1, workId);
      fetchConfirmAddComplete(1, workId);

      localStorage.setItem("done", JSON.stringify([{ wkID: value }]));
    }
  }

  // เมื่อมีการกด checkbox เช็คค่า localStorage ว่ามีการเก็บการจบการทำงานไหม
  // นำค่าพื้นหลังในการทำงานเสร็จสิ้นออก
  function checkBoxisChecking(workId) {
    // console.log("this doing++++++++++++++++++", workId);
    if (localStorage.getItem("done")) {
      let localDATA = JSON.parse(localStorage.getItem("done"));
      if (!localDATA[0]) {
        // console.log("end doing");
        document
          .getElementById(`card-grp-${workId}`)
          .classList.remove("card-check");
        document.getElementById(`thischeckGrid-${workId}`).checked = false;
      }
      //เมื่อกด checkbox ทำการเพิ่ม class เปลี่ยนสี่
      // localDATA.map((ele) => {
      //   if (parseInt(ele.wkID) === workId) {
      //     document
      //       .getElementById(`card-grp-${workId}`)
      //       .classList.add("card-check");
      //     document.getElementById(`thischeckGrid-${workId}`).checked = true;
      //   }
      //   // else {
      //   //   console.log("นี้ไม่เท่าไง");
      //   //   document
      //   //     .getElementById(`card-grp-${workId}`)
      //   //     .classList.remove("card-check");
      //   //   document.getElementById(`thischeckGrid-${workId}`).checked = false;
      //   // }
      // });
    }
  }

  //เมื่อมีการกด เปิดและปิด modal filter
  function handleOpenFilterModal(status) {
    if (status) {
      setFilterHandle(false);
      document.getElementById(`filterOpen`).style.display = "none";
      document.getElementById(`filterClose`).style.display = "block";
      document.getElementById(`modalFilterWork`).style.display = "block";
      document.getElementById(`boxFilterWork`).style.animation = "boxOpen 0.7s";
      document.getElementById(`boxFilterWork`).style.width = "50%";
      handleCloseNotificationbox();
      setTimeout(() => {
        document.getElementById(`infoFilterWork`).classList.add("info-show");
      }, 300);
    } else {
      setFilterHandle(true);
      document.getElementById(`filterClose`).style.display = "none";
      document.getElementById(`filterOpen`).style.display = "block";
      document.getElementById(`boxFilterWork`).style.animation =
        "boxClose 0.7s";
      document.getElementById(`boxFilterWork`).style.width = "0px";
      document.getElementById(`infoFilterWork`).classList.remove("info-show");
      setTimeout(() => {
        document.getElementById(`modalFilterWork`).style.display = "none";
      }, 700);
    }
  }
  const docid = (id) => {
    return document.getElementById(id);
  };
  function handleOpenDoctorChoice() {
    docid("modalDoctorChoice").style.display = "block";
    docid("showchoiceDoc").style.animation = "boxchoiceDocOpen 0.75s normal";
    setTimeout(() => {
      docid("showchoiceDoc").style.width = "80%";
      docid("contentChoiceDoc").style.display = "block";
    }, 740);
  }

  function handleOpenNotificationbox() {
    setStatusOpencloseNotification(false);
    docid("modalNotification").style.display = "block";
    docid("boxNotification").style.animation = "openNotification 0.75s normal";
    setTimeout(() => {
      docid("boxNotification").style.height = "100%";
      docid("infoNotification").style.display = "block";
    }, 700);
  }

  //จัดการรับค่า filter จาก localstorage
  function checkFilterWork() {
    if (localStorage.getItem("filterWork")) {
      let data = JSON.parse(localStorage.getItem("filterWork"));

      // console.log("look at here is a data parse-=>", data.amonth, data.ayear);

      getShowFilterWardlist(advisorData.advisor_id, data.amonth, data.ayear);
    }
  }

  //เปลี่ยนการแสดงข้อความ filter กรอง
  function handleHeadFiltershow() {
    if (localStorage.getItem("filterWork")) {
      let data = JSON.parse(localStorage.getItem("filterWork"));
      return `งาน ${handelMonthThai(`${data.amonth}`, "full")} ${data.yearth}`;
    } else {
      // return `งาน ${handelMonthThai(
      //   moment(today).format("MM"),
      //   "full"
      // )} ${moment(today).add(543, "year").format("YY")}`;
      return `งานทั้งหมด`;
    }
  }

  //จัดการกับฐานข้อมูล เมื่อกดจบการประเมินของงานนั้น ๆ
  function fetchConfirmAddComplete(thisStatus, thisWorkID) {
    let requestUP = {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        status: thisStatus,
        workID: thisWorkID,
      }),
    };
    let bodyrequest = {
      status: thisStatus,
      workID: thisWorkID,
    };

    fetch(
      `${http}/confirmAddComplete`,
      RequestFetch("PUT", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((message) => {
        console.log(message);
      })
    );
  }

  //ข้อมูลตัวเลือกอาจารย์
  function getDataDoctorchoice() {
    let localAdvisor = JSON.parse(localStorage.getItem("advisor"));
    let iddoc = localAdvisor.advisor_id;
    let requestFetch = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ doctorid: iddoc }),
    };
    let bodyrequest = {
      doctorid: iddoc,
    };

    console.log(">>>>", bodyrequest);
    fetch(
      `${http}/advisorChoice`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) => {
      res.json().then((data) => {
        // console.log("data advisorchoice >>", data);
        setAdvisorlistdata(data);
      });
    });
  }

  //ดูข้อมูลจารย์
  async function getDataLooknameAdvisor(id) {
    let requestlookname = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ advisorID: id }),
    };
    let bodyrequest = {
      advisorID: id,
    };

    let resultName = await fetch(
      `${http}/advisorNameLook`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) => {
      return res.json();
    });

    return resultName;
  }

  function handleCloselistDoctor() {
    // console.log("this....>>", wardroundList);
    document.getElementById("showchoiceDoc").style.animation =
      "boxchoiceDocClose 0.75s normal";
    document.getElementById("contentChoiceDoc").style.display = "none";
    setTimeout(() => {
      document.getElementById("showchoiceDoc").style.width = "0%";
      document.getElementById("modalDoctorChoice").style.display = "none";
    }, 720);
    setFinishSharestatus(true);
  }

  function handleCloseNotificationbox() {
    setStatusOpencloseNotification(true);
    handleBoxgradient(false, "box-notification");
    docid("boxNotification").style.animation = "closeNotification 0.75s normal";
    setTimeout(() => {
      docid("boxNotification").style.height = "0%";
      docid("modalNotification").style.display = "none";
    }, 700);
  }

  //เมื่อกดบนพื้นที่ที่ไม่ใช่พื้นที่ของ filter ให้ทำการปิดตัว modal filter ทิ้ง
  window.onclick = (e) => {
    if (document.getElementsByClassName("content-filterWork")[0]) {
      if (
        e.target === document.getElementsByClassName("content-filterWork")[0]
      ) {
        document.getElementById(`filterClose`).style.display = "none";
        document.getElementById(`filterOpen`).style.display = "block";
        document.getElementById(`boxFilterWork`).style.animation =
          "boxClose 0.7s";
        document.getElementById(`boxFilterWork`).style.width = "0px";
        document.getElementById(`infoFilterWork`).classList.remove("info-show");
        setTimeout(() => {
          document.getElementById(`modalFilterWork`).style.display = "none";
        }, 700);
      }
      if (
        e.target === document.getElementsByClassName("content-doctorchoice")[0]
      ) {
        handleCloselistDoctor();
      }
      if (
        e.target === document.getElementsByClassName("content-notification")[0]
      ) {
        handleCloseNotificationbox();
      }
    }
  };

  //เช็คค่า cookiesession ว่ามีค่าถอดรหัสตรงกับฐานข้อมูลหรือไม่ เพื่อกลับไปล็อคอินใหม่
  // ยังไม่ได้เพิ่มการล้างค่า ทั้งหมด
  // CheckingLogin().then((res) => {
  //   if (!res) {
  //     console.log("ต้องออกจากระบบ");
  //     Swal.fire({
  //       icon: "error",
  //       title: "!!เข้าสู่ระบบล้มเหลว!!",
  //       text: "กรุณาลองเข้าสู่ระบบอีกครั้ง",
  //       showConfirmButton: false,
  //       timer: 1400,
  //     });
  //     setTimeout(() => {
  //       window.location.href = "/estimate";
  //     }, 1400);
  //   }
  // });

  function filterTimer() {
    //polling เมื่อมีการรันโดยมีเลือกเดือนนั้น ๆ  filterWork
    if (!localStorage.getItem("filterWork")) {
      //polling เมื่อไม่มีการเลือกเดือน
      console.log(":-|");
      getShowWardround(advisorData.advisor_id);
      handleGetNotificationDATA();
      return;
    }
    console.log(":-3");
    checkFilterWork();
    handleGetNotificationDATA();
  }

  function wardinfoTimer() {
    //polling เมื่อมีการทำงานทั้งหมด ไม่มี filterwork
    if (localStorage.getItem("filterWork")) {
      //polling เมื่อมีการเลือกเดือน
      console.log(":)");
      handleGetNotificationDATA();
      checkFilterWork();
      return;
    }
    console.log(":3");
    getShowWardround(advisorData.advisor_id);
    handleGetNotificationDATA();
  }

  const [wardRuning, setWardRuning] = useState(false);
  const [filterRuning, setFilterRuning] = useState(false);
  const wardInterval = useRef(null);
  const filterInterval = useRef(null);

  useEffect(() => {
    Addmetatags();

    if (reload) {
      // console.log("reload");
      setReload(false);
    }
    if (localStorage.getItem("filterWork")) {
      checkFilterWork();
      selectfilterWork();
      setFilterRuning(true);
      handleGetNotificationDATA();
    } else {
      if (!usertoken) {
        Swal.fire({
          icon: "error",
          title: "!!เข้าสู่ระบบล้มเหลว!!",
          text: "กรุณาลองเข้าสู่ระบบอีกครั้ง",
          showConfirmButton: false,
          timer: 1400,
        });
        setTimeout(() => {
          window.location.href = "/estimate";
          cookies.remove("tokenEstimate");
        }, 1400);
      }
      getShowWardround(advisorData.advisor_id);
      selectfilterWork();
      setWardRuning(true);
      handleGetNotificationDATA();
    }
    //เมื่อรัน รีหน้าเพจใหม่
    // window.addEventListener("beforeunload", (e) => {
    //   e.preventDefault();
    //   const isReload = e.currentTarget.performance.navigation.type === 1;
    //   if (isReload) {
    //     console.log("Page reloading");
    //     let worklocalstorage = getdataAndDecodeStoreData("work");
    //     if (worklocalstorage) {
    //       setWardroundList(worklocalstorage);
    //     }
    //   }
    // });
  }, [location.search]);

  useEffect(() => {
    if (wardRuning) {
      // console.log("ทำตรงนี้มั้ยอะ!!! ไม่มีฟิวเตอร์", wardInterval.current);

      wardInterval.current = setInterval(() => {
        wardinfoTimer();
        ProtectedLogin(2, wardInterval.current, filterInterval.current);
      }, 3000);
    } else {
      clearInterval(wardInterval.current);
    }
  }, [wardRuning]);

  useEffect(() => {
    if (filterRuning) {
      console.log("ทำตรงนี้มั้ยอะ!!! มีฟิวเตอร์");
      filterInterval.current = setInterval(() => {
        filterTimer();
        ProtectedLogin(2, wardInterval.current, filterInterval.current);
      }, 3000);
    } else {
      clearInterval(filterInterval.current);
    }
  }, [filterRuning]);

  useEffect(() => {
    if (finishSharestatus) {
      // setInterval(() => {
      //   getShowWardround(advisorData.advisor_id);
      //   setFinishSharestatus(false);
      // }, 3000);
      getShowWardround(advisorData.advisor_id);
      setFinishSharestatus(false);
    }
  }, [finishSharestatus]);

  useEffect(() => {
    if (!wardroundList || !wardroundList[0]) return;

    // console.log("ตัวแปร wardroundList มีค่าเท่ากับ ==>", wardroundList);
    wardroundList.map((list) => {
      // console.log("ข้อมูลที่จะส่งไป", list.grop, advisorData.advisor_id);
      setTimeout(() => {
        getStudentInfo(list.gropID, advisorData.advisor_id);
      }, 200);
    });

    if (localStorage.getItem("done")) {
      let localDATA = JSON.parse(localStorage.getItem("done"));

      wardroundList.map((res) => {
        document
          .getElementById(`card-grp-${res.workID}`)
          .classList.remove("card-check");
        document.getElementById(`thischeckGrid-${res.workID}`).checked = false;

        document
          .getElementById(`text-namework-${res.workID}`)
          .classList.remove("card-has-asses");

        localDATA.map((ele) => {
          if (parseInt(ele.wkID) === res.workID) {
            document
              .getElementById(`card-grp-${res.workID}`)
              .classList.add("card-check");
            document.getElementById(
              `thischeckGrid-${res.workID}`
            ).checked = true;
          }
        });
      });
    }
    // console.log("this data wordroundList >", wardroundList);
    let arrsheet_studentgrp = []; //ใช้เพื่อเก็บรายการ กลุ่มนักศึกษา ใน sheet 5 6
    let lengthdataward = wardroundList.length;
    wardroundList.map((res, index) => {
      // console.log("map wardroundList =>",res.workID,res.sheetID,res.gropID);
      checkWorkDetailCheckAssessment(res.workID, res.sheetID, res.gropID);
      //เช็ค sheet 5 6 รับชื่อกลุ่มนศพ
      if (res.sheetID === 5 || res.sheetID === 6)
        handleshowgrpReport(res.IdStudent).then((ele) => {
          //รับค่า เพื่อเซ็ต
          arrsheet_studentgrp.push({
            id: res.IdStudent,
            grp: ele,
            sheetid: res.sheetID,
            idwork: res.workID,
          });
          // setReportstudentgroup([
          //   { ...reportstudentgroup },
          //   { id: res.IdStudent, grp: ele },
          // ]);
        });
    });
    setReportstudentgroup(arrsheet_studentgrp);
  }, [wardroundList]);

  useEffect(() => {
    if (localStorage.getItem("filterWork")) {
      console.log(
        "มีกรองข้อมูลตามเดือน",
        JSON.parse(localStorage.getItem("filterWork"))
      );
    } else {
      console.log("ไม่มีการกรองตามข้อมูลตามเดือนนี้นา");
      setWardroundList(getdataAndDecodeStoreData("work"));
    }
  }, [localStorage.getItem("filterWork")]);

  async function handleShowingInfomation() {}

  function disableCheckbox(datacheck, idwork) {
    let dis = true;
    datacheck.map((ele) => {
      if (ele.workid === idwork) {
        dis = false;
      }
    });
    return dis;
  }

  function handleShowboxcaseshare(mode) {
    let boxlenght = document.getElementsByClassName("box-showshare").length;

    if (mode) {
      // console.log("เปิด",mode);
      handleBoxgradient(mode, "box-shareMenu");
      setStatusOpencloseShare(false);
      for (let bl = 0; bl < boxlenght; bl++) {
        document.getElementsByClassName("checkboxwork")[bl].style.display =
          "none";
        document.getElementsByClassName("box-showshare")[bl].style.animation =
          "showshareBoxOpen 0.75s normal";
        document.getElementsByClassName("text-box-card")[bl].style.animation =
          "openshareModalbox 0.75s normal";
        setTimeout(() => {
          document.getElementsByClassName("justshowShare-icon")[
            bl
          ].style.display = "block";
        }, 400);
        setTimeout(() => {
          document.getElementsByClassName("box-showshare")[bl].style.width =
            "10%";
          document.getElementsByClassName("text-box-card")[bl].style.width =
            "90%";
          document.getElementsByClassName("justshowShare-icon")[
            bl
          ].style.display = "block";
          document
            .getElementsByClassName("text-box-card")
            [bl].classList.add("gridCardcontentChange");
        }, 730);
      }
    } else {
      // console.log("ปิด", mode);
      handleBoxgradient(mode, "box-shareMenu");
      setStatusOpencloseShare(true);
      for (let bl = 0; bl < boxlenght; bl++) {
        document.getElementsByClassName("box-showshare")[bl].style.animation =
          "showshareBoxClose 0.75s normal";
        document.getElementsByClassName("text-box-card")[bl].style.animation =
          "closeshareModalbox 0.75s normal";
        document.getElementsByClassName("justshowShare-icon")[
          bl
        ].style.display = "none";
        setTimeout(() => {
          document.getElementsByClassName("box-showshare")[bl].style.width =
            "0%";
          document.getElementsByClassName("text-box-card")[bl].style.width =
            "100%";
          document.getElementsByClassName("checkboxwork")[bl].style.display =
            "block";
        }, 730);
        setTimeout(() => {
          document
            .getElementsByClassName("text-box-card")
            [bl].classList.remove("gridCardcontentChange");
        }, 750);
      }
    }
  }

  function handleBoxgradient(mode, id) {
    if (mode) {
      document.getElementById(id).classList.add("boxChoiceGradient");
    } else {
      document.getElementById(id).classList.remove("boxChoiceGradient");
    }
  }

  function handleShareingwork(docid, idwork) {
    let bodyrequestfetch = {
      workid: idwork,
      shareiddoc: docid,
    };
    let bodyrequestmessage = {
      workid: idwork,
      shareiddoc: docid,
      ownId: advisorData.advisor_id,
    };
    // console.log(
    //   "ลิงค์ที่จะทำหน้า pageconfirm",
    //   `http://localhost:3000/estimate/confirmsharework/${btoa(
    //     encodeDataforkey(bodyrequestmessage)
    //   )}`
    // );
    fetch(
      `${http}/workupdateshare`,
      RequestFetch("PUT", bodyrequestfetch, usertoken)
    ).then((res) => {
      res.json().then((message) => {
        console.log(message);
      });
    });

    fetch(
      `${http}/messageAdd`,
      RequestFetch("POST", bodyrequestmessage, usertoken)
    ).then((res) => {
      res.json().then((message) => {
        console.log(message.message);
      });
    });
  }

  //ยังไม่ได้ทำให้ real time และ เช็คเงื่อนไขเวลาในการแชร์
  function handlecheckconfirmshare(docid, docShareid, workid, sheetname) {
    console.log("คลิกแล้วแสดงค่าหน่อย >>", docid, docShareid, workid);
    if ((!docid, !docShareid, !workid)) return;
    if (docid === docShareid) {
      // console.log("ยอมรับการแลกเปลี่ยนแชร์");
      Swal.fire({
        title: "ยอมรับการแลกเปลี่ยน",
        text: `ท่านต้องการแลกเปลี่ยน ${sheetname} ใช่หรือไม่?`,
        icon: "info",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((res) => {
        if (res.isConfirmed) {
          // let requestfetchconfirm = {
          //   method: "PUT",
          //   headers: { "content-type": "application/json" },
          //   body: JSON.stringify({
          //     workid: workid,
          //     docown: docid,
          //     docshare: docShareid,
          //   }),
          // };

          // let requestmessageconfirm = {
          //   method: "PUT",
          //   headers: { "content-type": "application/json" },
          //   body: JSON.stringify({ workID: workid, advisorID: docShareid }),
          // };
          let bodyfetchconfirm = {
            workid: workid,
            docown: docid,
            docshare: docShareid,
          };
          let bodymessageconfirm = {
            workID: workid,
            advisorID: docShareid,
          };
          // console.log("requset >>", requestmessageconfirm);
          fetch(
            `${http}/messageconfirm`,
            RequestFetch("PUT", bodymessageconfirm, usertoken)
          ).then((res) =>
            res.json().then((data) => {
              console.log(data.message);
              Swal.fire({
                icon: "success",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 1200,
              });
            })
          );
          fetch(
            `${http}/workconfirmshare`,
            RequestFetch("PUT", bodyfetchconfirm, usertoken)
          ).then((res) =>
            res.json().then((message) => {
              console.log(message.message);
              Swal.fire({
                icon: "success",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 1200,
              });
            })
          );
          // setFinishSharestatus(true);
        }
      });
    } else if (docid !== docShareid) {
      // console.log("ยกเลิกการแลกเปลี่ยนแชร์");
      Swal.fire({
        title: "ยกเลิกการแลกเปลี่ยน",
        text: "ท่านต้องการยกเลิกการแชร์ ใช่หรือไม่?",
        icon: "question",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((res) => {
        if (res.isConfirmed) {
          // let requestFetchunshare = {
          //   method: "PUT",
          //   headers: { "content-type": "application/json" },
          //   body: JSON.stringify({ workid: workid }),
          // };
          // let requestCancle = {
          //   method: "PUT",
          //   headers: { "content-type": "application/json" },
          //   body: JSON.stringify({
          //     idwork: workid,
          //     idadvisor: docShareid,
          //   }),
          // };

          let bodyFetchunshare = {
            workid: workid,
          };
          let bodyCancle = {
            idwork: workid,
            idadvisor: docShareid,
          };

          // console.log(requestCancle);

          fetch(
            `${http}/workunshare`,
            RequestFetch("PUT", bodyFetchunshare, usertoken)
          ).then((res) =>
            res.json().then((message) => {
              console.log(message.message);
              Swal.fire({
                icon: "success",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 1200,
              });
              setFinishSharestatus(true);
            })
          );

          fetch(
            `${http}/messagecancle`,
            RequestFetch("PUT", bodyCancle, usertoken)
          ).then((res) =>
            res.json().then((message) => {
              console.log(message.message);
            })
          );
        }
      });
    } else {
      return;
    }
  }

  function handleDoneShowshare(workID) {
    let done = JSON.parse(localStorage.getItem("done"));
    let res = false;
    done.map((data) => {
      if (data.wkID.toString() === workID.toString()) {
        res = true;
      }
    });
    return res;
  }
  useEffect(() => {
    if (!datascoreCheckshare) return;
    console.log("this a datascore", datascoreCheckshare);
    console.log("this a count", datascoreCheckshare.length);
  }, [datascoreCheckshare]);

  function handlecheckDatemonthshare(datadate) {
    let date = new Date();
    let day = (key) => {
      return moment(key).add(543, "year").format("DD");
    };
    let month = (key) => {
      return moment(key).add(543, "year").format("MM");
    };
    let year = (key) => {
      return moment(key).add(543, "year").format("YYYY");
    };
    if (parseInt(year(datadate)) >= parseInt(year(date))) {
      if (parseInt(month(datadate)) >= parseInt(month(date))) {
        if (parseInt(day(datadate)) >= parseInt(day(date))) {
          // console.log("day",day(datadate),day(date))
          // console.log("month",month(datadate),month(date))
          // console.log("year",year(datadate),year(date))
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  function handleLookmessage(advisorID) {
    // let requestFetch = {
    //   method: "PUT",
    //   headers: { "content-type": "application/json" },
    //   body: JSON.stringify({ advisorID: advisorID }),
    // };
    let bodyrequest = {
      advisorID: advisorID,
    };
    //เขียนอัพเช็ค เมื่อมีการเปิด notification

    fetch(
      `${http}/messagelook`,
      RequestFetch("PUT", bodyrequest, usertoken)
    ).then((message) => {
      console.log(message.message);
    });

    fetch(
      `${http}/messagelookConfirm`,
      RequestFetch("PUT", bodyrequest, usertoken)
    ).then((message) => {
      console.log(message.message);
    });
  }

  function handlereadmessage(Id, idadvisor) {
    // console.log(Id);
    let requestread = {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ messageid: Id, advisorID: idadvisor }),
    };

    let bodyrequestread = {
      messageid: Id,
      advisorID: idadvisor,
    };

    fetch(
      `${http}/messageread`,
      RequestFetch("PUT", bodyrequestread, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        console.log(data.message);
      })
    );
  }

  function handlereadmessageConfirm(id, ownid) {
    let requestreadConfirm = {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ messageid: id, advisorshare: ownid }),
    };

    let bodyrequest = {
      messageid: id,
      advisorshare: ownid,
    };
    fetch(
      `${http}/messagereadconfirm`,
      RequestFetch("PUT", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        console.log(data.message);
      })
    );
  }

  function handleGetNotificationDATA() {
    let requestDataNotis = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ idadvisor: advisorData.advisor_id }),
    };
    let bodydatanotis = {
      idadvisor: advisorData.advisor_id,
    };
    fetch(
      `${http}/messageshare`,
      RequestFetch("POST", bodydatanotis, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        // console.log("ดูใหม่ แม่นก่อ>", data);
        let numberNotification = 0;
        data.map((ele) => {
          if (
            ele.status_read === 0 &&
            parseInt(ele.id_advisor) === parseInt(advisorData.advisor_id) &&
            ele.cancle === 0
          ) {
            numberNotification++;
          } else if (
            parseInt(ele.id_advisor_share) ===
              parseInt(advisorData.advisor_id) &&
            ele.confirm === 1 &&
            ele.cancle === 2 &&
            ele.status_read < 3
          ) {
            numberNotification++;
          }
        });
        if (numberNotification) {
          setStatusNotification(true);
        } else {
          setStatusNotification(false);
        }
        setNotificationnumber(numberNotification);
        setDataforNotification(data);
      })
    );
  }

  function showNotisInfo(data, index) {
    // console.log(data);
    let showNormal = () => {
      return (
        <div
          className="dropdown-card-noti"
          id={`dropnoti-${index}`}
          style={
            data.cancle === 1
              ? { backgroundColor: "#fde0dc" }
              : { backgroundColor: "#dcedc8" }
          }
        >
          <div className="info-notidrop" id={`infonotidrop-${index}`}>
            <p className="p-sheet">
              {data.cancle === 1
                ? `ยกเลิกการแลกเปลี่ยน`
                : `ยืนแลกเปลี่ยนการประเมิน`}
            </p>
            <p className="p-sheet">
              <b>
                {`${
                  data.sheetname
                    ? data.sheetname.split("แบบฟอร์ม")[1]
                      ? data.sheetname.split("แบบฟอร์ม")[1]
                      : data.sheetname.trim()
                    : ""
                }`}
              </b>
            </p>
            <p>{`ของ`}</p>
            <p className="p-month">
              <b>{`วันที่ ${moment(data.date).format(
                "DD"
              )} เดือน ${handelMonthThai(
                moment(data.date).format("MM"),
                "full"
              )} ปี ${moment(data.date).format("YYYY")}`}</b>
            </p>

            <p>{`จาก `}</p>
            <p className="p-advisor">
              <b>{`${data.share_ttl} ${
                data.share_name ? data.share_name.trim() : ""
              } ${data.share_lname ? data.share_lname.trim() : ""}`}</b>
            </p>
            {data.cancle === 1 ? (
              ""
            ) : data.confirm === 1 ? (
              ""
            ) : (
              <p
                className="p-underline"
                onClick={() => {
                  handlecheckconfirmshare(
                    advisorData.advisor_id,
                    data.id_advisor,
                    data.workid,
                    data.sheetname
                  );
                }}
              >
                {`คลิกตอบรับการแลกเปลี่ยน`}
              </p>
            )}
          </div>
        </div>
      );
    };

    if (data.confirm === 1) {
      if (data.id_advisor === advisorData.advisor_id) {
        return showNormal();
      } else if (data.id_advisor_share === advisorData.advisor_id) {
        return (
          <div
            className="dropdown-card-noti"
            style={{ backgroundColor: "#dcedc8" }}
            id={`dropnoti-${index}`}
          >
            <div className="info-notidrop" id={`infonotidrop-${index}`}>
              <p className="p-confirm">{`${data.share_ttl} ${data.share_name} ${data.share_lname}`}</p>
              <p className="p-confirm-bold">{`ยอมรับการแลกงานประเมิน`}</p>
              <p className="p-confirm-bold">{`${data.sheetname}`}</p>
              <p className="p-confirm">{`ของวันที่ ${moment(data.date)
                .add(543, "year")
                .format("DD/MM/YYYY")}`}</p>
            </div>
          </div>
        );
      }
    } else if (data.confirm === 0) {
      if (data.id_advisor_share !== advisorData.advisor_id) {
        return showNormal();
      }
    }
  }

  function handleColorCardNotification(key, ownshare) {
    if (key === 0 || key === 1) {
      return { backgroundColor: "#cfd8dc" };
    } else if (key === 2 || key === 4) {
      return { backgroundColor: "#f5f5f5" };
    } else if (key === 3 && ownshare === advisorData.advisor_id) {
      return { backgroundColor: "#cfd8dc" };
    }
  }

  async function handleshowgrpReport(idstd) {
    try {
      const result = await fetch(
        `${http}/studentDetail`,
        RequestFetch("POST", { id: idstd }, usertoken)
      ).then((res) =>
        res.json().then((data) => {
          // console.log("data", data);
          return data[0].groupname;
        })
      );
      return result;
    } catch (error) {
      console.error("handleshowgrpReport", error);
    }
  }

  return (
    <div className="wardround-list-page">
      <div
        className="nav-wardround"
        onClick={() => {
          handleCloseNotificationbox();
        }}
      >
        <div className="title-listWork">
          <div className="filter-yearmonth">
            <div
              className="col1-grid-year"
              onClick={() => {
                filterHandle === true
                  ? handleOpenFilterModal(true)
                  : handleOpenFilterModal(false);
              }}
            >
              <p>{handleHeadFiltershow()}</p>
            </div>
            <div className="col2-grid-year">
              <i
                className="bi-chevron-compact-right"
                id="filterOpen"
                onClick={() => {
                  handleOpenFilterModal(true);
                }}
              ></i>
              <i
                className="bi-chevron-compact-left"
                id="filterClose"
                onClick={() => {
                  handleOpenFilterModal(false);
                }}
                style={{ display: "none" }}
              ></i>
            </div>
          </div>
          <p>{`อ.${advisorData ? advisorData.advisor_name : ""}`}</p>
        </div>
      </div>
      <div className="body-content">
        {wardroundList
          ? wardroundList.map((data, key) => (
              <div
                className="card-content"
                style={
                  !data.share
                    ? { borderBottom: "1px solid #e0e0e0" }
                    : data.share === advisorData.advisor_id
                    ? data.confirm === 1
                      ? { borderBottom: "2px solid #d4e157" }
                      : { borderBottom: "2px solid #81d4fa" }
                    : data.cancle === 2
                    ? { borderBottom: "2px solid #d4e157" }
                    : { borderBottom: "2px solid #ffa000" }
                }
                id={`card-grp-${data.workID}`}
                key={key}
              >
                <div className="text-box-card">
                  <div className="grid-check">
                    <input
                      type="checkbox"
                      className="checkboxwork"
                      id={`thischeckGrid-${data.workID}`}
                      value={data.workID}
                      onChange={(e) => {
                        // console.log(checkingBox);

                        if (checkingBox[0]) {
                          let doing = true;
                          checkingBox.map((res) => {
                            if (res.workId === data.workID) {
                              if (res.status === false) {
                                console.log("this doing ?");
                                doing = false;
                              }
                            }
                          });
                          if (doing) {
                            // console.log("ทำงานตรงนี้นะ !!!");

                            handleSetLocalTohighlight(
                              e.target.value,
                              data.workID
                            );
                            checkBoxisChecking(data.workID);
                          } else {
                            Swal.fire({
                              icon: "error",
                              text: "ประเมินนักศึกษายังไม่ครบ",
                              showConfirmButton: false,
                              timer: 1500,
                            });
                            document.getElementById(
                              `thischeckGrid-${data.workID}`
                            ).checked = false;
                          }
                        } else {
                          handleSetLocalTohighlight(
                            e.target.value,
                            data.workID
                          );
                          checkBoxisChecking(data.workID);
                        }
                      }}
                      disabled={disableCheckbox(
                        undisbleFinishwork,
                        data.workID
                      )}
                    ></input>
                    <button className="btn-shareboxwork">
                      <Icon icon="fluent:share-20-regular" />
                    </button>
                  </div>
                  <div
                    className="grid-date"
                    onClick={() => {
                      handelChooseListWork(
                        data.gropID,
                        data.sheetID,
                        data.workID,
                        data.IdStudent,
                        data.share,
                        data.sheet,
                        data.confirm,
                        new Date(data.date).getFullYear()
                      );
                    }}
                  >
                    <div>
                      <span className="text-card">
                        {`
                      ${
                        data.date !== "0000-00-00"
                          ? moment(data.date).format("DD")
                          : "00"
                      } 
                      ${
                        data.date !== "0000-00-00"
                          ? handelMonthThai(
                              moment(data.date).format("MM"),
                              "drop"
                            )
                          : "00"
                      }
                      `}
                      </span>
                    </div>
                  </div>
                  <div
                    className="grid-sheetname"
                    id={`text-namework-${data.workID}`}
                  >
                    <div
                      onClick={(e) => {
                        handelChooseListWork(
                          data.gropID,
                          data.sheetID,
                          data.workID,
                          data.IdStudent,
                          data.share,
                          data.sheet,
                          data.confirm,
                          new Date(data.date).getFullYear()
                        );
                      }}
                    >
                      {/* <span className="text-card">{data.sheet}</span> */}
                      <span className="text-card">
                        {data.sheetID === 5
                          ? data.sheet.split("แบบฟอร์ม")[1]
                            ? data.sheet.split("แบบฟอร์ม")[1]
                            : data.sheet
                          : data.sheet}
                      </span>
                    </div>
                    <div
                      onClick={(e) => {
                        handelChooseListWork(
                          data.gropID,
                          data.sheetID,
                          data.workID,
                          data.IdStudent,
                          data.share,
                          data.sheet,
                          data.confirm,
                          new Date(data.date).getFullYear()
                        );
                      }}
                    >
                      <div className="time-text">
                        {data.timebegin !== "" ? (
                          data.timeend !== "" ? (
                            <span>{`${data.timebegin}-${data.timeend}`}</span>
                          ) : (
                            "00:00-00:00"
                          )
                        ) : (
                          "00:00-00:00"
                        )}
                      </div>
                    </div>
                    <div
                      className="boxshare-status"
                      style={
                        !data.share ? { display: "none" } : { display: "block" }
                      }
                    >
                      <button
                        className="btn-sharestatus"
                        type="button"
                        onClick={() => {
                          let advisor = JSON.parse(
                            localStorage.getItem("advisor")
                          );
                          // console.log("เช็ wardlist >>", wardroundList);
                          if (parseInt(data.confirm) === 0 || !data.confirm) {
                            handlecheckconfirmshare(
                              advisor.advisor_id,
                              data.share,
                              data.workID,
                              data.sheet
                            );
                          } else {
                            if (data.share !== advisorData.advisor_id) {
                              let promissname = getDataLooknameAdvisor(
                                data.share
                              );
                              promissname.then((data) => {
                                // console.log(">>?", data);
                                Swal.fire({
                                  icon: "info",
                                  title: "ผู้รับผิดชอบประเมินงาน",
                                  text: `${data[0].ttl} ${data[0].name} ${data[0].lname} เป็นผู้รับผิดชอบประเมินงานแทน`,
                                  confirmButtonText: "ตกลง",
                                });
                              });
                            } else {
                              Swal.fire({
                                icon: "info",
                                title: "รับผิดชอบงานแทน",
                                text: `${data.advisor_ttl} ${data.advisor_name} ${data.advisor_lname} เป็นผู้รับผิดชอบงานประเมิน`,
                                confirmButtonText: "ตกลง",
                              });
                            }
                          }
                        }}
                      >
                        <i
                          className="icon-hanshake"
                          style={
                            data.share === advisorData.advisor_id
                              ? { color: "#81d4fa" }
                              : { color: "#ffa000" }
                          }
                        >
                          {/* <Icon
                            icon="fa:handshake-o"
                            width={"25"}
                            height={"25"}
                          /> */}
                          {/* <Icon icon="fa6-solid:hand-holding-hand" width={"25"} height={"25"}/> */}
                          <MyiconTwohand
                            style={
                              data.share === advisorData.advisor_id
                                ? { fill: "#81d4fa" }
                                : { fill: "#ffa000" }
                            }
                          />
                        </i>
                        <p
                          className="p-permissStatus"
                          style={
                            data.share === advisorData.advisor_id
                              ? { color: "#455a64" }
                              : { color: "#a47454" }
                          }
                        >
                          {data.share === advisorData.advisor_id
                            ? "รออนุมัติ"
                            : "รอยืนยัน"}
                        </p>
                      </button>
                    </div>
                  </div>
                  <div
                    className="grid-group"
                    onClick={() => {
                      handelChooseListWork(
                        data.gropID,
                        data.sheetID,
                        data.workID,
                        data.IdStudent,
                        data.share,
                        data.sheet,
                        data.confirm,
                        new Date(data.date).getFullYear()
                      );
                    }}
                  >
                    <span className="text-card">
                      {data.IdStudent
                        ? // <i className="bi-person">
                          //   {reportstudentgroup.map((ele) => {
                          //     if (
                          //       ele.id === data.IdStudent &&
                          //       ele.sheetid === data.sheetID
                          //     ) {
                          //       return ele.grp;
                          //     }
                          //   })}
                          // </i>
                          reportstudentgroup.map((ele) => {
                            if (
                              ele.id === data.IdStudent &&
                              ele.sheetid === data.sheetID &&
                              ele.idwork === data.workID
                            ) {
                              return ele.grp;
                            }
                          })
                        : data.grop}
                    </span>
                  </div>
                </div>
                {/* <div className="text-box-card2">
                  
                </div> */}
                <div className="box-showshare" id="boxShowshare">
                  <div className="justshowShare-icon">
                    <button
                      className="btn-iconarrowshare"
                      id={`btniconarrowshare-${data.workID}`}
                      type="button"
                      style={
                        data.sheetID === 1 || data.sheetID === 8
                          ? !data.share
                            ? JSON.parse(localStorage.getItem("done"))[0]
                              ? handleDoneShowshare(data.workID)
                                ? // ? { color: "#bdbdbd" }
                                  { display: "none" }
                                : handlecheckDatemonthshare(data.date) === true
                                ? { color: "#33691e" }
                                : { color: "#33691e" }
                              : // { display: "none" }
                              handlecheckDatemonthshare(data.date) === true
                              ? { color: "#33691e" }
                              : { color: "#33691e" }
                                // { display: "none" }
                            : // : { color: "#bdbdbd" }
                              { display: "none" }
                          : { display: "none" }
                      }
                      // disabled={
                      //   !data.share
                      //     ? JSON.parse(localStorage.getItem("done"))[0]
                      //       ? handleDoneShowshare(data.workID)
                      //         ? true
                      //         : handlecheckDatemonthshare(data.date) === true
                      //         ? false
                      //         : true
                      //       : handlecheckDatemonthshare(data.date) === true
                      //       ? false
                      //       : true
                      //     : true
                      // }
                      onClick={() => {
                        console.log("this open choice", data.workID);
                        setHolderWorkid(data.workID);
                        handleOpenDoctorChoice(choiceDoctorshare);
                        getDataDoctorchoice();
                      }}
                    >
                      <Icon icon="fluent:share-20-regular" />
                    </button>
                    <button type="button" style={{ display: "none" }}>
                      <Icon icon="fa:handshake-o" width={"25"} height={"25"} />
                    </button>
                  </div>
                </div>
              </div>
            ))
          : ""}
        {/* <div className="box-showshare" id="boxShowshare">
          <span>{"TEST"}</span>
        </div> */}
      </div>
      <div className="footer-nav">
        <div
          className="box-relative"
          id="box-notification"
          onClick={() => {
            handleGetNotificationDATA();
          }}
        >
          {/* เมื่อกดออก หรือ ปิดหน้าแสดง การแจ้งเตือน ให้ทุกค่าที่เปิดรายละเอียดปิด */}
          <i
            className="icon-footer-nav bi-bell-fill"
            onClick={() => {
              handleBoxgradient(true, "box-notification");
              handleOpenNotificationbox();
              handleLookmessage(advisorData.advisor_id);
              if (!statusOpencloseNotification) {
                handleCloseNotificationbox();
              }
              if (!statusOpencloseShare) {
                handleShowboxcaseshare(statusOpencloseShare);
              }
            }}
            style={
              statusNotification ? { display: "block" } : { display: "none" }
            }
          >
            <div
              className="number-notification"
              style={
                statusNotification ? { display: "flex" } : { display: "none" }
              }
            >
              <span>{notificationnumber}</span>
            </div>
          </i>
          <i
            className="icon-footer-nav bi-bell"
            onClick={() => {
              handleBoxgradient(true, "box-notification");
              handleOpenNotificationbox();
              if (!statusOpencloseNotification) {
                handleCloseNotificationbox();
              }
              if (!statusOpencloseShare) {
                handleShowboxcaseshare(statusOpencloseShare);
              }
            }}
            style={
              statusNotification ? { display: "none" } : { display: "block" }
            }
          ></i>
          <span className="span-footer-nav">{`แจ้งเตือน`}</span>
        </div>
        <div className="box-relative">
          <i></i>
        </div>
        <div
          className="box-relative"
          id="box-shareMenu"
          onClick={() => {
            console.log("handle to sharebutton on page");
            handleShowboxcaseshare(statusOpencloseShare);
            if (!statusOpencloseNotification) {
              handleCloseNotificationbox();
            }
          }}
        >
          <i className="icon-footer-nav icon-share-regular">
            <Icon icon="fluent:share-20-regular" />
          </i>
          <span className="span-footer-nav">{`แลกงาน`}</span>
        </div>
        <div className="box-relative">
          <i
            className="icon-footer-nav bi-box-arrow-left"
            onClick={() => {
              setWardRuning(false);
              setFilterRuning(false);
              Swal.fire({
                title: "ออกจากระบบ!",
                text: "ต้องการออกจากระบบ ใช่ หรือ ไม่ ?",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
                icon: "warning",
              }).then((res) => {
                if (res.isConfirmed) {
                  navigat("/");
                  localStorage.removeItem("filterWork");
                  localStorage.clear();
                  cookies.remove("tokenEstimate", {
                    path: "/",
                  });
                } else {
                  if (localStorage.getItem("filterWork")) {
                    setFilterRuning(true);
                  } else {
                    setWardRuning(true);
                  }
                }
              });
            }}
          ></i>
          <span className="span-footer-nav">{`ออกระบบ`}</span>
        </div>
      </div>
      <div className="modal-filter-work" id="modalFilterWork">
        <div className="content-filterWork">
          <div className="box-filter-work" id="boxFilterWork">
            <div className="info-filter-work" id="infoFilterWork">
              <div
                className="card-filter-content"
                onClick={() => {
                  // console.log("จัดการแสดงทั้งหมดสิงับ");
                  localStorage.removeItem("filterWork");
                  getShowWardround(advisorData.advisor_id);
                  handleOpenFilterModal(false);
                }}
              >
                <div className="info-filter-content">
                  <span>{`งานทั้งหมด`}</span>
                </div>
              </div>
              {filterWork[0]
                ? filterWork.map((res, index) => (
                    <div
                      className="card-filter-content"
                      key={index}
                      onClick={() => {
                        //ตัดการ เพิ่มสีและเช็คบนเช็คบล็อค
                        let l = 0;
                        while (
                          l <
                          document.getElementsByClassName("card-content").length
                        ) {
                          document
                            .getElementsByClassName("card-content")
                            [l].classList.remove("card-check");
                          document.getElementsByClassName("checkboxwork")[
                            l
                          ].checked = false;

                          l++;
                        }
                        handleFilterSETwork(
                          res.monthNum,
                          res.fullYear,
                          res.year
                        );
                      }}
                    >
                      <div className="info-filter-content">
                        <span>{`${res.month} ${res.year}`}</span>
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-doctorchoice" id="modalDoctorChoice">
        <div className="content-doctorchoice">
          <div className="box-doctorchoice" id="showchoiceDoc">
            <div className="showContent-boxdoc" id="contentChoiceDoc">
              <div className="nav-header-boxdoctorchoice">
                <h2>{"แลกกับอาจารย์"}</h2>
              </div>
              <div className="info-boxdoctorchoice">
                {advisorlistdata.map((data, index) => {
                  return (
                    <div
                      className="this-carddoctor-list"
                      key={index}
                      onClick={() => {
                        let textalert = `ต้องการแลกเปลี่ยนกับ \n ${data.ttl} ${data.name} ${data.lname} \n ใช่ หรือ ไม่ ?`;
                        Swal.fire({
                          title: "แลกเปลี่ยนการประเมิน",
                          text: textalert,
                          showConfirmButton: true,
                          showCancelButton: true,
                          confirmButtonText: "ตกลง",
                          confirmButtonColor: "green",
                          cancelButtonText: "ยกเลิก",
                        }).then((res) => {
                          if (res.isConfirmed) {
                            handleShareingwork(data.id, holderWorkid);
                            setTimeout(() => {
                              handleCloselistDoctor();
                            }, 500);
                          }
                        });
                      }}
                    >
                      <span>
                        {data.ttl + " " + data.name + " " + data.lname}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-notification" id="modalNotification">
        <div className="content-notification">
          <div className="box-notification" id="boxNotification">
            <div className="showContent-notification" id="infoNotification">
              {dataforNotification[0]
                ? dataforNotification.map((data, index) => {
                    //เขียนแสดง noti
                    // console.log("###", data);
                    let info = () => {
                      return (
                        <div className="box-show-noti" key={index}>
                          <div
                            className="card-showinfo-notification"
                            style={
                              (data.id_advisor === advisorData.advisor_id
                                ? { display: "grid" }
                                : data.id_advisor_share ===
                                  advisorData.advisor_id
                                ? data.confirm === 1
                                  ? { display: "grid" }
                                  : { display: "none" }
                                : { display: "none" },
                              handleColorCardNotification(
                                data.status_read,
                                data.id_advisor_share
                              ))
                            }
                            onClick={() => {
                              if (
                                data.status_read === 0 ||
                                data.status_read === 1
                              ) {
                                handlereadmessage(data.Id, data.id_advisor);
                              } else if (
                                data.status_read === 3 &&
                                data.id_advisor_share === advisorData.advisor_id
                              ) {
                                handlereadmessageConfirm(
                                  data.Id,
                                  data.id_advisor_share
                                );
                              }
                              if (
                                docid(`caretdown-${index}`).style.display ===
                                "block"
                              ) {
                                docid(`dropnoti-${index}`).style.display =
                                  "flex";
                                docid(`dropnoti-${index}`).style.animation =
                                  "dropdownCardNotiOpen 0.3s normal";
                                docid(`infonotidrop-${index}`).style.animation =
                                  "infonotidropOpen 0.3s normal";
                                docid(`infonotidrop-${index}`).style.opacity =
                                  "1";
                                docid(`dropnoti-${index}`).style.height =
                                  "220px";
                                setTimeout(() => {
                                  docid(`caretdown-${index}`).style.display =
                                    "none";
                                  docid(`upshownoti-${index}`).style.display =
                                    "block";
                                }, 200);
                              } else if (
                                docid(`upshownoti-${index}`).style.display ===
                                "block"
                              ) {
                                docid(`dropnoti-${index}`).style.animation =
                                  "dropdownCardNotiClose 0.3s normal";
                                docid(`infonotidrop-${index}`).style.animation =
                                  "infonotidropClose 0.3s normal";
                                docid(`dropnoti-${index}`).style.height = "0px";
                                setTimeout(() => {
                                  docid(`dropnoti-${index}`).style.display =
                                    "none";
                                  docid(`upshownoti-${index}`).style.display =
                                    "none";
                                  docid(`caretdown-${index}`).style.display =
                                    "block";
                                }, 200);
                              }
                            }}
                          >
                            <i className="i-iconchat bi-chat-left-text"></i>
                            <span
                              className="span-headerNoti"
                              style={
                                data.cancle === 1
                                  ? { color: "red" }
                                  : data.confirm === 1
                                  ? { color: "#33691e" }
                                  : { color: "#006064" }
                              }
                            >
                              {data.cancle === 1
                                ? `${data.share_ttl} ${data.share_name} ยกเลิกการแลกเปลี่ยน`
                                : data.confirm === 1
                                ? data.id_advisor_share ===
                                  advisorData.advisor_id
                                  ? `${data.share_ttl} ${data.share_name} ยอมรับการแลกเปลี่ยน`
                                  : `${data.share_ttl} ${data.share_name} ยื่นแลกเปลี่ยนงานกับท่าน`
                                : `${data.share_ttl} ${data.share_name} ยื่นแลกเปลี่ยนงานกับท่าน`}
                            </span>
                            <button
                              className="btn-caret-notification"
                              type="button"
                              id={`caretdown-${index}`}
                              style={{ display: "block" }}
                            >
                              <i className="bi-caret-down"></i>
                            </button>
                            <button
                              className="btn-caret-notification"
                              type="button"
                              id={`upshownoti-${index}`}
                              style={{ display: "none" }}
                            >
                              <i className="bi-caret-up"></i>
                            </button>
                          </div>
                          {showNotisInfo(data, index)}
                        </div>
                      );
                    };
                    if (data.confirm === 1) {
                      if (
                        data.id_advisor === advisorData.advisor_id ||
                        data.id_advisor_share === advisorData.advisor_id
                      ) {
                        return info();
                      }
                    } else if (data.confirm === 0) {
                      if (data.id_advisor === advisorData.advisor_id) {
                        return info();
                      }
                    }
                  })
                : ""}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Wardroundpage;
